module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3XDdX"))).then(() => parcelRequire('d0iPb'));